/**
 * Canvas object chrome — the kit contract (M2, rulings of 2026-08-12).
 *
 * The chrome is UI, not content: screen-constant (counter-scaled) above T2,
 * identical on every node. These constants ARE the contract — the client
 * layout math and the agent surface (prompt row pitches, clearances) derive
 * from them rather than restating numbers. Source of truth for the design:
 * the design system's `staging/object-matrix-v2` exhibit (regime lab) and
 * its delta ledger.
 */

/** Zoom at which verbs, eye, and foot leave — uniformly, on every node. */
export const CHROME_T1 = 0.5;

/** Zoom below which the label stops counter-scaling and recedes with the
 *  canvas. The counter-scale is `1 / max(zoom, CHROME_T2)`; layout freezes
 *  at the T2 state. */
export const CHROME_T2 = 0.3;

/** Icon seat (touch/hover target), px. The glyph inside renders 13px at
 *  stroke-width 2 (entity-cards recipe) — that lives in the CSS. */
export const CHROME_ICON_SEAT = 20;

/** Gap between chrome elements inside a band, px. */
export const CHROME_GAP = 4;

/** Extra breath between the label and the eye, px — keeps the revealed
 *  backing chips separated and gives the title-edit focus ring clearance
 *  (the label's chip pads 4px into the base gap). */
export const CHROME_EYE_GAP_EXTRA = 4;

/** Gap between a band and the node edge, px (DS --space-1_5). */
export const CHROME_BAND_GAP = 6;

/** Band height, px — the icon seat sets it. */
export const CHROME_BAND_H = 20;

/** The label never truncates below this, px. Ruled simple: on a very
 *  narrow node the label may shrink to a character or two on hover —
 *  a recorded niggle, deliberately not engineered around. */
export const CHROME_LABEL_FLOOR = 12;

/** Screen px a band + its gap claim beyond the node edge — what layout
 *  (tidy, section fit, agent placement) must clear above and below a
 *  chrome-wearing node. */
export const CHROME_CLEARANCE = CHROME_BAND_H + CHROME_BAND_GAP;

/** Sticky note sizing canon (ruled 2026-08-12): both square. */
export const NOTE_DEFAULT_SIZE = 288;
export const NOTE_MIN_SIZE = 160;
